import { NativeModules, NativeEventEmitter } from 'react-native';
import { MkodoEvent } from '../state/mkodo.types';
import { MkodoModule } from './mkodo.types';

export const { NativeMkodo } = NativeModules as { NativeMkodo: MkodoModule };

export const addListener = (handler: (event: MkodoEvent) => void) =>
  new NativeEventEmitter(NativeMkodo).addListener('onMkodoEvent', handler);

export const loadMkodoScript = () => {
  if ('mGeoJS' in window) {
    return;
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.id = 'mgeo-engine';
    script.src = '/mkodo/mGeoJS-4.2.14.min.js';
    script.onload = resolve;
    script.onerror = reject;

    document.head.append(script);
  });
};
